import D1 from '../../maps/D1.json';
import D2 from '../../maps/D2.json';
import D3 from '../../maps/D3.json';
import D4 from '../../maps/D4.json';
import D5 from '../../maps/D5.json';
import D6 from '../../maps/D6.json';
import D7 from '../../maps/D7.json';
import type { DailyMap, DateKey } from '../types.js';
function freezeDeep<T>(value: T): T {
  if (value && typeof value === 'object') { Object.freeze(value); Object.values(value).forEach(freezeDeep); }
  return value;
}
export const MAP_VERSION = 'maps.v1';
export const MAPS = freezeDeep({ D1, D2, D3, D4, D5, D6, D7 } as Record<DateKey, DailyMap>);
export const maps = MAPS;
export function getMap(dateKey: DateKey): DailyMap {
  const map = MAPS[dateKey];
  if (!map) throw new Error('Unknown activity date');
  return map;
}
